import { render } from "./KnowledgePage.vue?vue&type=template&id=a4d29ae4"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__